import React from 'react';
import CompactTableRow from '@/components/table/CompactTableRow';
import ClauseCounts from '../../profile/components/ClauseCounts';
import QueryClauseTableRowOr from './QueryClauseTableRowOr';
import QueryClauseTableRowName from './QueryClauseTableRowName';

const QueryClauseTableRow = ({
  category,
  code,
  clause,
  queryUUID,
  canEdit,
  firstClause,
  isEditing,
}) => (
  <CompactTableRow
    className="aridhia-query-clause-table-row"
    numberOfColumns={6}
    active
  >
    <QueryClauseTableRowOr
      firstClause={firstClause}
      isEditing={isEditing}
    />
    <QueryClauseTableRowName
      canEdit={canEdit}
      category={category}
      clause={clause}
      code={code}
      isEditing={isEditing}
      queryUUID={queryUUID}
    />
    <ClauseCounts
      category={category}
      code={code}
      clauseUUID={clause.uuid}
      queryUUID={queryUUID}
    />
  </CompactTableRow>
);

export default QueryClauseTableRow;
